export default __webpack_public_path__ + "static/media/tulflix_logo-full.49b0b67c.png";